import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "ServiceBlockedModal"
}
const _hoisted_2 = { class: "ServiceBlockedDetails" }
const _hoisted_3 = { class: "ServiceBlockedMessage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("p", null, [
      _createElementVNode("i", { class: "lnr-notification-circle ServiceBlockedModalIcon" })
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "ServiceBlockedTitle" }, "Service Temporarily Unavailable", -1 /* CACHED */)),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.blockReason), 1 /* TEXT */)
    ])
  ], 512 /* NEED_PATCH */))
}